import { type FC } from "react"

const Loader: FC<{ label: string }> = ({ label }) => (
	<div className="flex flex-col items-center justify-center py-10">
		<div className="relative mb-6 h-10 w-10">
			<span className="bg-primary absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"></span>
			<span className="bg-primary relative inline-flex h-10 w-10 rounded-full"></span>
		</div>
		<span className="text-lg font-medium text-slate-600">{label}</span>
	</div>
)

export const SmallLoader: FC<{ label: string }> = ({ label }) => (
	<div className="flex flex-col items-center justify-center py-6">
		<div className="relative mb-4 h-6 w-6">
			<span className="bg-primary absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"></span>
			<span className="bg-primary relative inline-flex h-6 w-6 rounded-full"></span>
		</div>
		<span className="text-sm font-medium text-slate-600">{label}</span>
	</div>
)

export default Loader
